import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Buttons = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 30px;
`;

export const Div = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;

  span {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #4caf50;
  }
`;
